// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"style__pageTitle__BqFyW","pageMenu":"style__pageMenu__FEn28"};